import React, { useState } from "react";
import { Col, Container, Row } from "react-grid-system";
import {
  Button,
  MobileModalContent,
  MobilePageDescription,
  MobilePageHeader,
} from "../../components";
import { useTranslation } from "react-i18next";

const RowColWrapper = ({ children }) => (
  <Row>
    <Col xs={12}>{children}</Col>
  </Row>
);

const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

const ModalSaveCard = ({ cardUrl, webCardUrl }) => {
  const { t } = useTranslation();
  const [downloaded, setDownloaded] = useState(false);
  const androidUrl = webCardUrl || cardUrl;
  const url = isIOS
    ? cardUrl
    : `${androidUrl}${androidUrl.includes("?") ? "&" : "?"}install=1`;

  return (
    <Container>
      <MobileModalContent height={"100%"}>
        <RowColWrapper>
          <MobilePageHeader>
            {t("views.modal_save_card.header")}
          </MobilePageHeader>
        </RowColWrapper>

        <RowColWrapper>
          <MobilePageDescription>
            {t("views.modal_save_card.desc")}
          </MobilePageDescription>
        </RowColWrapper>

        <RowColWrapper>
          <Button
            type={"primary"}
            display={"block"}
            tag={"a"}
            href={url}
            onClick={() => (isIOS ? setDownloaded(true) : null)}
          >
            {t("views.modal_save_card.btn_save")}
          </Button>
        </RowColWrapper>

        {downloaded && (
          <RowColWrapper>
            <Button
              type={"secondary"}
              display={"block"}
              tag={"a"}
              href="wallet://"
            >
              {t("views.modal_save_card.btn_open_wallet")}
            </Button>
          </RowColWrapper>
        )}
      </MobileModalContent>
    </Container>
  );
};

export default ModalSaveCard;
